import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CalculateIcon from "@mui/icons-material/Calculate";
import { numericFormatter } from "react-number-format";
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';

export const slaReportingColumns = (editSlaReporting, viewActions, viewCompanyOverview): GridColDef[] => {
    return [

        {
            field: "companyName",
            headerName: "CRM Client Name",
            editable: false,
            width: 250,
            sortable: false,
            renderCell: (params) => (
                <Box
                    sx={{
                        color: "primary.main",
                        cursor: "pointer",
                        textDecoration: "underline",
                        "&:hover": {
                            color: "primary.dark",
                        },
                    }}
                    onClick={() => viewCompanyOverview(params.row.companyRowID)}
                >
                    {params.value}
                </Box>
            ),
        },
        {
            field: "imperansCompanyName",
            headerName: "Imperans Client Name",
            editable: false,
            width: 250,
            sortable: false,
        },
        {
            field: "primaryCompanyRelationshipManagerName",
            headerName: "Primary Relationship Holder",
            editable: false,
            width: 250,
            sortable: false,
        },
        {
            field: "slaStatus",
            headerName: "SLA Status",
            editable: false,
            width: 150,
            sortable: false,
        },
        {
            field: "slaExpiryDateFormated",
            headerName: "SLA Expiry Date",
            editable: false,
            width: 200,
            sortable: false,
        },
        {
            field: "totalAnnualRevenue",
            headerName: "Total Estimated Annual Revenue",
            editable: false,
            width: 250,
            sortable: false,
            renderCell: (params) => {
                const formattedValue = numericFormatter(`${params.value}`, {
                    thousandSeparator: true,
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    prefix: "$",
                });
                const invoiceSource = params.row.invoiceSource;

                return (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <span>{formattedValue}</span>
                        {invoiceSource === "Xero" && (
                            <Tooltip title="Xero-verified revenue">
                                <CheckCircleIcon
                                    sx={{
                                        fontSize: "1.2rem",
                                        color: "#4caf50",
                                        cursor: "pointer",
                                    }}
                                />
                            </Tooltip>
                        )}
                        {invoiceSource === "Imperans" && (
                            <Tooltip title="Estimated from Imperans test data">
                                <CalculateIcon
                                    sx={{
                                        fontSize: "1.2rem",
                                        color: "#ff9800",
                                        cursor: "pointer",
                                    }}
                                />
                            </Tooltip>
                        )}
                    </Box>
                );
            },
        },
        {
            field: "edit",
            headerName: "View SLA Status",
            editable: false,
            width: 300,
            sortable: false,
            renderCell: (params) => (
                <IconButton
                    color="primary" onClick={() => editSlaReporting(params.row)}
                >
                    <EditTwoToneIcon />
                </IconButton>
            ),
        },
        {
            field: "assign",
            headerName: "View Actions",
            editable: false,
            width: 150,
            sortable: false,
            renderCell: (params) => (
                <IconButton
                    color="primary"
                    onClick={() => viewActions(params.row)}
                >
                    <VisibilityTwoToneIcon />
                </IconButton>
            ),
        },
    ]
}